import React from "react";
import { useState, useEffect } from "react";
import { ArrowLeftCircleIcon } from "@heroicons/react/24/outline";

const Vision = () => {
  const storedData = sessionStorage.getItem("upcomingEvents");
  const initialUpcomingEvents = storedData ? JSON.parse(storedData) : [];
  const [allUpcomingEvents, setAllUpcomingEvents] = useState(
    initialUpcomingEvents
  );
  useEffect(() => {
    if (!storedData) {
      fetch(`https://al-maghrib-server.vercel.app/upcomingEvent/all`)
        .then((res) => res.json())
        .then((data) => {
          setAllUpcomingEvents(data.upcomingEvents);
          sessionStorage.setItem(
            "upcomingEvents",
            JSON.stringify(data.upcomingEvents)
          );
        });
    }
  }, []);
  return (
    <div className="bg-white py-12 sm:py-20">
      <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center bg-blue-400 border border-blue-200 rounded-lg overflow-hidden">
  {/* 1 */}
  <div className="order-1 p-4 md:p-6 text-center text-white">
    <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">
      Our Vision
    </h2>
    <p className="text-lg leading-relaxed text-justify">
    To be the best Premium and Transparent Islamic school that represents a holistic and caring environment that nurtures excellence in academic and moral education. We aim to create successful learners, responsible Muslim citizens, confident individuals, and accountable leaders that will serve humanity. We also believe in character before brilliance, and that every child is unique and capable of learning.
    </p>
  </div>

  {/* 2 */}
  <div className="order-2 p-4 md:p-6">
    <div className="w-full aspect-video">
      <iframe
        src="https://www.youtube.com/embed/XOi_k28PCJQ?autoplay=1"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="w-full h-full rounded-lg"
      ></iframe>
    </div>
  </div>

  {/* 3 → will appear 4th on small screens */}
  <div className="order-4 md:order-3 p-4 md:p-6">
    <div className="w-full aspect-video">
      <iframe
        src="https://www.youtube.com/embed/fbvf25mjpsA?si=SO5tXeiHreu8tlLG"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="w-full h-full rounded-lg"
      ></iframe>
    </div>
  </div>

  {/* 4 → will appear 3rd on small screens */}
  <div className="order-3 md:order-4 p-4 md:p-6 text-center text-white">
    <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">
      Relieve the Spirit of <br /> Inter-School Quran Competition
    </h2>
    <div className="hidden md:flex justify-center">
      <ArrowLeftCircleIcon className="w-[5vw]" />
    </div>
  </div>
</div>

      </div>
    </div>
  );
};

export default Vision;
